import { FC } from 'react';
import { Link } from 'react-router-dom';
import { usePlanStatus } from '../../hooks/usePlanStatus';
import styles from './PlanQuotaWidget.module.scss';

export const PlanQuotaWidget: FC = () => {
  const { data, isLoading } = usePlanStatus();
  if (isLoading || !data) return null;

  const { plan, currentAthleteCount, effectiveMaxAthletes, percentUsed, isOverLimit } = data;
  const barClass = isOverLimit
    ? styles.barOver
    : percentUsed >= 80
    ? styles.barWarn
    : styles.barOk;

  return (
    <Link
      to="/dashboard/profile/abbonamento"
      className={styles.widget}
      title={`Piano: ${plan.name} · Limite ${effectiveMaxAthletes} · Disponibili ${Math.max(0, effectiveMaxAthletes - currentAthleteCount)}`}
    >
      <div className={styles.title}>Piano {plan.name}</div>
      <div className={styles.barTrack}>
        <div className={`${styles.bar} ${barClass}`} style={{ width: `${Math.min(100, percentUsed)}%` }} />
      </div>
      <div className={styles.label}>
        <span>{currentAthleteCount}/{effectiveMaxAthletes}</span>
        <span className={styles.unit}>atleti</span>
      </div>
    </Link>
  );
};
